import { AxiosError, AxiosResponse } from 'axios';
import { Dispatch } from '@reduxjs/toolkit';

import { GlobalService } from './global.service';

import { AXIOS, CommonGlobalService, UUID, CallbackErrorAxios, CallbackWarningAxios } from '@umanforge/common';
import { Planning } from 'interfaces/planning.interface';
import { API } from 'constants/api.contants';


export class PlanningService {

  static getPlanningBySectorId(
    sectorId: UUID,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<Planning> {
    return new Promise( async resolve => {
      AXIOS.get( `${API.PLANNING_BY_SECTOR}/${sectorId}`, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse<Planning> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }
};